export default __webpack_public_path__ + "static/media/12.49df308e.jpg";